// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'normalize.css/normalize.css'
import '@/styles/bootstrap/css/bootstrap.min.css'
import 'swiper/dist/css/swiper.css'
import '@/styles/base.scss'
import App from './App'
import store from './store'
import router from './router'
import '@/permission'
import VueBreadcrumbs from 'vue-breadcrumbs'
import breadcrumbs from '@/components/breadcrumbs'
import '@/utils/filters'

Vue.prototype.imgFilter= function (data) {
  if(data){
    return data.replace(/src=\"\//g,'src="'+process.env.BASE_URL+'/').replace(/src=\'\//g,"src='"+process.env.BASE_URL+"/")
  }
};
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.use(VueBreadcrumbs,breadcrumbs)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js